module.exports = __webpack_public_path__ + "img/community-active.25358ede.png";